import styled from 'styled-components';
import {grid} from '../../utils/styled/_grid.style';
import {animations, colors, devices, fonts} from '../../utils/styled/_variables.styled';
import {InfiosButton} from '../Button/Button.style';
import {InfiosLanguageSelectorWrapper} from '../LanguageSelector/LanguageSelector.style';
import {InfiosSearchNavigation, InfiosSearchSuggestions} from '../SearchNavigation/SearchNavigation.style';
import {InfiosBurgerLine} from './HeaderBurger/HeaderBurger.style';
import {InfiosLink} from '../Link/Link.style';
import {InfiosInputWrapper} from '../FormComponents/Input/Input.style';
import { InfiosHeaderNavigation } from "./HeaderNavigation/HeaderNavigation.style";

export const InfiosHeaderContainer = styled.section`
    position: relative;

    ${props => !props.isMobile && `
        align-items: center;
    `}
`;

export const InfiosHeaderMetaWrapper = styled.section`
    position: relative;
    justify-content: flex-end;
    flex-basis: 100%;
    max-height: 25px;
    overflow: hidden;

    .search-component {
        margin: 0;
    }
`;

export const InfiosHeaderWrapper = styled.section`
	position: relative;
	justify-content: flex-end;
	align-items: center;
	margin-left: auto;
	row-gap: 16px;

	> .header-navigation > button {
		margin-left: 45px;
		border-radius: 28px;
		background: ${props => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.bluegray : colors.limeGreen)};
		color: ${props => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.white : colors.bluegray)};
		font-family: ${fonts.AeonikMono};
		font-size: 12.414px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
		text-transform: uppercase;
		letter-spacing: -0.248px;


		&.contact-form {
			padding: 7px 11px;
		}

		svg {
			width: 9.31px;
			height: 9.31px;
			margin-left: 6px;

			path {
				fill: ${props => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.white : colors.bluegray)};
			}
		}

		&:hover {
			background: ${colors.bluegray};
			color: ${colors.white};

			svg {
				transform: translate(0, 0);
			}
		}

		${props => props.isMobile && `
            line-height: 16px;

            &.contact-form {
                padding: 6px 9px;
            }
        `}
	}

	${props => !props.isMobile && `
        flex-wrap: wrap;
    `}

	.header-navigation {
		display: flex;
		flex-wrap: nowrap;
		overflow: unset;

		${props => !props.isMobile && `
			flex-wrap: nowrap;
			* {
				flex: 0 0 auto;
			}
		`}
		${props => props.isMobile && `
			flex-direction: row-reverse;
			justify-content: flex-start;
		`}
	}

`;

export const InfiosHeaderLogo = styled.a`
    position: relative;
    justify-content: center;
    align-items: center;

		img {
			object-fit: contain;
		}

   ${props => !props.isMobile && `
        img {
            height: 62px;
            width: 157px;
        }
    `}

    ${props => props.isMobile && `
        img {
            height: 37px;
            max-height: 37px;
            width: 94px;
        }
    `}

    @media ${devices.mobile} {
        img {
            height: 37px;
            max-height: 37px;
            width: 94px;
        }
    }
`;

export const InfiosHeader = styled.section`
    ${grid};
    position: ${props => props.isInEditor ? "relative" : "fixed"};
    ${props => ((props.blackLetter === "whiteBlack") ? `background: ${colors.white};` : '')};
    top: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 40px;
    max-height: 130px;
    padding-top: 47px;
    padding-bottom: 21px;
    z-index: 3;
    transition: ${animations.defaultTransition};

    * {
        transition: ${animations.defaultTransition};
    }


    ${InfiosButton} {
        transition: ${animations.buttonLink};
    }

    ${InfiosInputWrapper},
    ${InfiosSearchSuggestions} {
        max-width: 870px;
    }

    ${InfiosSearchSuggestions} {
        position: absolute;
        width: 100%;
        top: -9px;
        background: ${colors.white};
        z-index: 1;

        ${props => !props.isMobile && `
            position: initial;
        `}
    }

    &:hover,
    &.open,
    &.collapsed {
        background-color: ${colors.white};

        a {
            &:not(:hover) {
                color: ${colors.bluegray};
            }
        }

        ${InfiosBurgerLine} {
            background: ${colors.infiosGray};
        }

        ${InfiosSearchNavigation},
        ${InfiosLanguageSelectorWrapper} {
            svg {
                path {
                    fill: ${colors.infiosGray};
                }
            }
        }


        .select__single-value {
            &:not(:hover) {
                color: ${colors.bluegray};
            }
        }

        .select__control {
            &:hover {
                svg {
                    path {
                        fill: ${colors.blueHover};
                    }
                }
                .select__single-value {
                    color: ${colors.blueHover};
                }
            }
        }

        ${InfiosButton} {
            &.tertiary {
                &:not(:hover) {
                    color: ${colors.bluegray};
                }
            }
        }

        ${InfiosSearchSuggestions} {
            ${InfiosLink} {
                &:not(:hover),
                &:not(:hover) {
                    color: ${colors.blue};
                }
            }
        }
    }

    ${props => !props.isMobile && `
        padding-right: 100px;
        padding-left: 100px;
    `}

   ${props => props.isMobile && `
        padding: 16px 20px 16px;

        ${InfiosButton} {
            padding: 8px 12px;
        }
    `}

    ${props => {
        if(props.isCollapsed) return `

        & {
                ${props => !props.isMobile && `
                    padding-top: 12px;
                    padding-bottom: 12px;

                    ${InfiosHeaderContainer} {
                           align-items: center;
                    }
                `}
            }

            ${InfiosHeaderMetaWrapper} {
                max-height: 0;
            }

            ${InfiosHeaderWrapper} {
                gap: 0;
            }

            ${InfiosHeaderLogo} {
                img {
										${props => !props.isMobile && `
											height: 62px;
											width: 157px;
										`}
                }
            }
        `}
    }

	.contact-form {
        background: ${props => props.contactButtonColor || colors.limeGreen};
        color: ${props => props.contactButtonTextColor || colors.infiosGray};

        ${props => !props.isMobile && `
            order: 1;
        `}

        svg path {
            fill: ${props => props.contactButtonTextColor || colors.infiosGray};
        }

        &:hover {
            background: ${props => props.contactButtonHoverColor || colors.infiosGray};
            color: ${props => props.contactButtonTextHoverColor || colors.white};
						svg path {
						fill: ${props => props.contactButtonTextHoverColor || colors.white};
					}
        }
    }
`;
